import { DataTypeProvider } from '@devexpress/dx-react-grid'
import { consolidationStatusMap } from '@returnmates/client-core/src/constants/trip'
import { memo } from 'react'

import { getStatusIcons } from '../../../pages/Main/constants'
import { StatusIconProps } from '../../../pages/Main/types'
import CellIcon from '../../CellIcon'
import useStyles from '../styles'

function PickupCellFormatter({ value, column }: DataTypeProvider.ValueFormatterProps) {
  const classes = useStyles()

  return (
    <>
      {column.name === 'status' ? (
        <div className={classes.iconCell}>
          <CellIcon iconComponent={getStatusIcons(value as StatusIconProps)} />
          {consolidationStatusMap(value)}
        </div>
      ) : null}
      {column.name === 'expectedDeliveryDate' ? <div>{value ? value : '-'}</div> : null}
    </>
  )
}

export default memo(PickupCellFormatter)
